import { isDayjs } from "dayjs";
import { type ParsedQs, parse, stringify } from "qs";

export const parseSearchString = (search: string): ParsedQs => {
  return parse(search.slice(1));
};

export const createSearchString = (obj: object): string => {
  return stringify(obj);
};

export const convertStringUndefined = (obj: any): any => {
  function convert(value: unknown): unknown {
    if (value === "undefined") {
      return undefined;
    } else if (isDayjs(value)) {
      return value.format();
    } else {
      return value;
    }
  }

  return Object.keys(obj).reduce((acc, key) => {
    return {
      ...acc,
      [key]: convert(obj[key]),
    };
  }, {});
};
